import React from 'react';
import { browserHistory } from 'react-router';

import Url from '../../lib/url';
import OrderTypeButton from '../../components/order-type-button';

class OrderStart extends React.Component {
  componentWillMount() {
    const orderConfig = this.props.app.config.order;
    if (orderConfig.types.length === 1) {
      const urlToFn = orderConfig.types[0] === 'delivery' ?
        Url.orderDelivery :
        Url.orderTakeAway;
      browserHistory.push(urlToFn(this.props.url.appId));
    }
  }
  render() {
    const appId = this.props.url.appId;
    return (
      <div className="grow orderStart">
        <div className="orderType">
          <OrderTypeButton appId={appId} type="delivery">
            Consegna a domicilio
          </OrderTypeButton>
          <OrderTypeButton appId={appId} type="takeAway">
            Asporto
          </OrderTypeButton>
        </div>
      </div>
    );
  }
}

export default OrderStart;



// WEBPACK FOOTER //
// ./src/containers/order/order-start.js